export const dirname = (path) => path?.split('/').slice(0, -1).join('/');
//# sourceMappingURL=dirname.js.map